import { render, staticRenderFns } from "./boxRecord.vue?vue&type=template&id=70493e05&"
import script from "./boxRecord.vue?vue&type=script&lang=js&"
export * from "./boxRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "boxRecord.vue"
export default component.exports